import TableVM from '../table-vm';
import GradebookServices from '../services';
export default Kadenze.Util.extendObj(TableVM, function(student_id) {
  var self = this;
  self.$el = $('#grades-tab-content');
  self.request_pool = new Kadenze.AjaxRequestPool();
  self.filter_options = ko.observable({'submissions': ['ungraded', 'partially_graded', 'not_submitted', 'submitted', 'student_action_required']});
  self.params = {
    filters: ko.observableArray([]),
    search: ko.observable('')
  };
  self.student_id = ko.observable();
  self.coursework_ids = ko.observableArray([]);
  self.courseworks = ko.observableArray();
  self.attendance = ko.observable();
  self.lab_attendance = ko.observable();

  self.initUI = function() {
    var $searchEl = $('#gradesSearch');
    $searchEl.on('keypress', function(event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13') {
        $searchEl.blur();
      }
    });
  };

  self.filterChanged = function () {
    self.$el.click(); //Hack to close selectpicker & menus
    self.request_pool.abortAll();
    self.showPlaceholder('loading');
    if (self.mp)
      self.mp.end();
    self.getSheet(ko.mapping.toJS(self.params));
  };

  self.bindFilters = function () {
    _.each(_.keys(self.params), function (key) {
      self.params[key].subscribe(self.filterChanged);
    });
  };

  self.getSheet = function(params) {
    params = params ? params : ko.mapping.toJS(self.params);
    var url = Kadenze.Routes.show_course_gradebook_grades_path(self.course_id, 'student', self.student_id(), params);

    self.courseworks([]);

    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      timeout: 60000,
      beforeSend: function (xhr, settings) {
        self.request_pool.add(xhr);
      }
    });

    request.done(function(data) {
      self.bindData(data);
    });

    request.fail(function(xhr, textStatus, message) {
      if (textStatus == 'abort') {
        return;
      }
      new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
      console.warn('Error retrieving sheet data:', xhr);
    });

    return request;
  };

  self.bindData = function(data) {
    self.coursework_ids(data.coursework_ids);
    if (typeof data.attendance != 'undefined') {
      self.attendance(ko.mapping.fromJS(data.attendance));
    }

    if (typeof data.lab_attendance != 'undefined') {
      self.lab_attendance(ko.mapping.fromJS(data.lab_attendance));
    }

    if (self.coursework_ids().length > 0) {
      self.mp = new Mprogress({
        template: 1,
        start: true,
        parent: '#' + self.$el.attr('id') + ' .display-table'
      });

      self.getCoursework(self.coursework_ids()[0]);

      self.hidePlaceholder();
    } else {
      self.showPlaceholder('no_results');
    }
  };

  self.getCoursework = function(coursework_id) {
    var url = Kadenze.Routes.show_row_course_gradebook_grades_path(self.course_id, coursework_id, self.student_id());

    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      data: null,
      timeout: 60000,
      beforeSend: function (xhr, settings) {
        self.request_pool.add(xhr);
      }
    });

    request.done(function(data) {
      var mapped_coursework = ko.mapping.fromJS(data);
      self.courseworks.push(mapped_coursework);

      var completion = self.courseworks().length / self.coursework_ids().length;
      self.mp.set(completion);
      if (completion == 1) {
        self.mp.end();
      } else {
        var index = self.coursework_ids.indexOf(coursework_id);
        self.getCoursework(self.coursework_ids()[index + 1]);
      }
    });

    request.fail(function(xhr, textStatus, message) {
      if (textStatus == 'abort') {
        return;
      }
      console.log('Error retrieving row data:', xhr);
    });
  };

  self.exportTable = function () {
    var url = Kadenze.Routes.export_course_gradebook_grades_path(self.course_id, {subject: 'student', subject_id: self.student_id()});
    GradebookServices.sendRequest(url, 'POST', self.$el);
    Kadenze.Analytics.track('grade', 'download', {type: 'student_grades'});
  };

  self.openSubmission = function (item, event) {
    var msg = 'Are you sure you want to allow {first_name} {last_name} to submit {coursework}'.supplant(
      {first_name: item.student_data.first_name(), last_name: item.student_data.last_name(), coursework: item.coursework_data.name()});
    GradebookServices.openSubmission(item, event, msg);
  };

  self.markAsSubmitted = function (item, event) {
    GradebookServices.markAs(item, event, 'submitted');
  };

  self.markAsUnsubmitted = function (item, event) {
    GradebookServices.markAs(item, event, 'unsubmitted');
  };

  self.downloadSubmission = function (item, event) {
    GradebookServices.downloadSubmission(item, event);
  };

  self.showSpeedGrader = function (item, event) {
    GradebookServices.initSpeedGrader(item, event, self.params.filters(), function () {
      //Refresh coursework row after close
      var url = Kadenze.Routes.show_row_course_gradebook_grades_path(self.course_id, item.coursework_data.id(), self.student_id());
      GradebookServices.sendRequest(url, 'GET', self.$el).done(function (data) {
        _.each(_.keys(data), function (key) {
          if (ko.isObservable(item[key]))
            item[key](data[key]);
        });
      });
    });
  };

  const __construct = function(that) {
    console.log('constructor called for InstructorGradebook.Student.GradesVM');
    that.course_id = $('#course_id').val();
    that.showPlaceholder('loading');
    that.bindFilters();

    that.student_id.subscribe(that.filterChanged);
    that.student_id(student_id);
  }(this);
});

